import {Col, Row} from "antd";
import React from "react";
import DashboardWelcomeCard from "./DashboardWelcomeCard";
import DashboardCalendarCard from "./DashboardCalendarCard";
import DashboardPatientsCard from "./DashboardPatientsCard";
import DashboardStatistcsCard from "./DashboardStatistcsCard";

const DashboardMobile = () => {
    return (
        <>
            <Row gutter={[32, 32]}>
                <Col span={24}>
                    <DashboardWelcomeCard/>
                </Col>
            </Row>
            <Row gutter={[32, 32]}>
                <Col span={24}>
                    <DashboardCalendarCard/>
                </Col>
            </Row>
            <Row gutter={[32, 32]}>
                <Col span={24}>
                    <DashboardPatientsCard/>
                </Col>
            </Row>
            <Row gutter={[32, 32]}>
                <Col span={24}>
                    <DashboardStatistcsCard/>
                </Col>
            </Row>
        </>
    )
}

export default DashboardMobile;

